import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { LangProvider } from './i18n';
import { initTelegram } from './tg';

// Take over the viewport + theme when launched inside Telegram (no-op elsewhere).
initTelegram();

async function root() {
  // DEV-only visual harnesses (see src/dev/Preview.tsx).
  if (
    import.meta.env.DEV &&
    ['#preview', '#home', '#lobby', '#role', '#gameover', '#cards', '#flatline', '#spectate'].includes(
      location.hash,
    )
  ) {
    const { Preview } = await import('./dev/Preview');
    return <Preview />;
  }
  return <App />;
}

root().then((el) =>
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <LangProvider>{el}</LangProvider>
    </StrictMode>,
  ),
);
